import React, { Component } from 'react'
import { TextField, Button, Select, MenuItem, IconButton, Icon, Card, CardContent } from '@material-ui/core'
import Http from '../../../Http'
import { withRouter } from "react-router-dom";
import Toast from 'react-hot-toast';

class Circuito extends Component {

  constructor(props) {
    super(props)

    this.state = {
      id: null,
      sucursales: [],
      circuito: '',
      sucursalesOptions: [],
      deletedsucursales: [],
      saving: false,
    }
  }

  async componentDidMount() {
    await this.FillForm();
    if (this.props.match.params.id) {
      await this.LoadPreds();
    }
  }

  LoadPreds = async () => {
    let id = this.props.match.params.id;
    let Res = await Http.get(`circuito/one/${id}`);
    if (!Res.error && Res.data) {
      const rawSucursales = Res.data.sucursales || [];
      const sucursales = rawSucursales.map((s, idx) => {
        const idSuc = typeof s === 'object' && s !== null ? (s.id_sucursal || s.id) : s;
        return {
          id_sucursal: Number(idSuc) || '',
          orden: typeof s === 'object' && s && s.orden ? Number(s.orden) : idx + 1,
          horas_tramo: typeof s === 'object' && s && s.horas_tramo ? parseFloat(s.horas_tramo) : 0,
          km_tramo: typeof s === 'object' && s && s.km_tramo ? parseFloat(s.km_tramo) : 0,
          tiempo_operativo: 2.0, // Fijo en 120 min
        };
      });

      this.setState({ sucursales, circuito: Res.data.circuito || '', id: Res.data.id }, this.updateDynamicName);
    }
  }

  FillForm = async () => {
    try {
      let Res = await Http.get(`sucursal/all`);
      if (!Res.error && Res.data) {
        const options = Array.isArray(Res.data) ? Res.data : (Res.data.data || []);
        this.setState({ sucursalesOptions: options });
      } else {
        this.setState({ sucursalesOptions: [] });
      }
    } catch (error) {
      console.log(error);
      this.setState({ sucursalesOptions: [] });
    }
  }

  onAddSucursal = () => {
    const { sucursales } = this.state;
    const newSucursal = {
      id_sucursal: '',
      orden: sucursales.length + 1,
      horas_tramo: 0,
      km_tramo: 0,
      tiempo_operativo: 2.0, // 120 min fijo
    };
    this.setState({ sucursales: [...sucursales, newSucursal] }, this.updateDynamicName);
  }

  onChangeSucursalId = (index, value) => {
    const sucursales = [...this.state.sucursales];
    sucursales[index] = {
      ...sucursales[index],
      id_sucursal: Number(value)
    };
    this.setState({ sucursales }, this.updateDynamicName);
  }

  onChangeTramoField = (index, field, value) => {
    const sucursales = [...this.state.sucursales];
    sucursales[index] = {
      ...sucursales[index],
      [field]: parseFloat(value) || 0
    };
    this.setState({ sucursales });
  }

  onMoveSucursal = (index, direction) => {
    const sucursales = [...this.state.sucursales];
    const targetIndex = index + direction;
    if (targetIndex < 0 || targetIndex >= sucursales.length) return;

    const temp = sucursales[index];
    sucursales[index] = sucursales[targetIndex];
    sucursales[targetIndex] = temp;

    // Recalcular orden secuencial
    sucursales.forEach((s, idx) => { s.orden = idx + 1; });
    this.setState({ sucursales }, this.updateDynamicName);
  }

  onRemoveSucursal = (index) => {
    let { sucursales, deletedsucursales } = this.state;
    const removed = sucursales[index];
    if (removed && removed.id_sucursal) {
      deletedsucursales.push(removed.id_sucursal);
    }
    const filtered = sucursales.filter((_, i) => i !== index);
    filtered.forEach((s, idx) => { s.orden = idx + 1; });

    this.setState({ sucursales: filtered, deletedsucursales }, this.updateDynamicName);
  }

  updateDynamicName = () => {
    const { sucursales, sucursalesOptions } = this.state;
    const sucursalMap = {};
    (sucursalesOptions || []).forEach(suc => {
      sucursalMap[suc.id] = suc.sucursal || suc.sucursal_nombre || `SUC_${suc.id}`;
    });

    const dynamicName = sucursales
      .filter(s => s.id_sucursal)
      .map(s => sucursalMap[s.id_sucursal] || s.id_sucursal)
      .join('-');

    this.setState({ circuito: dynamicName });
  }

  calculateTotalHours = () => {
    const { sucursales } = this.state;
    let horasTramoTotal = 0;
    let tiempoOperativoTotal = 0;

    sucursales.forEach((s, idx) => {
      // La última parada no tiene tránsito de salida
      if (idx < sucursales.length - 1) {
        horasTramoTotal += parseFloat(s.horas_tramo) || 0;
      }
      // Sumar tiempo operativo en estaciones intermedias (120 min / 2.0h)
      if (idx > 0 && idx < sucursales.length - 1) {
        tiempoOperativoTotal += 2.0;
      }
    });

    return {
      horasTramoTotal,
      tiempoOperativoTotal,
      total: horasTramoTotal + tiempoOperativoTotal
    };
  }

  onSave = async () => {
    const { circuito, sucursales, deletedsucursales, id } = this.state;
    
    if (!sucursales || sucursales.length < 2) {
      Toast.error('El circuito debe tener al menos 2 sucursales');
      return;
    }

    if (sucursales.some(s => !s.id_sucursal)) {
      Toast.error('Por favor seleccione la sucursal en todas las estaciones');
      return;
    }

    this.setState({ saving: true });
    try {
      const Resp = await Http.post('circuito/save', { circuito, sucursales, deletedsucursales, id });
      this.setState({ saving: false });

      if (!Resp.error) {
        Toast.success(`Circuito '${circuito}' guardado correctamente`);
        if (this.props.history) {
          this.props.history.push('/Catalogo/Circuitos');
        }
      } else {
        Toast.error(Resp.errMsg || 'Error al guardar el circuito');
      }
    } catch (error) {
      this.setState({ saving: false });
      Toast.error('Error al guardar el circuito');
    }
  }

  render() {
    const { sucursales, circuito, sucursalesOptions, saving } = this.state;
    const totals = this.calculateTotalHours();
    const safeOptions = Array.isArray(sucursalesOptions) ? sucursalesOptions : [];

    return (
      <div style={{ padding: 25 }}>
        <Card variant="outlined" style={{ marginBottom: 20 }}>
          <CardContent>
            <h3 style={{ marginBottom: 15 }}>Configuración de Circuito por Tramos</h3>
            <div className="row" style={{ marginBottom: 15 }}>
              <div className="col-md-6 col-sm-12">
                <TextField
                  fullWidth
                  label="Nombre del Circuito (Generado automáticamente)"
                  value={circuito}
                  disabled
                  variant="outlined"
                  helperText="El nombre se genera concatenando el orden de las sucursales"
                />
              </div>
              <div className="col-md-6 col-sm-12 style-summary" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <div style={{ fontWeight: 'bold', fontSize: '1.1rem', color: '#1976d2' }}>
                  Horas Totales Acumuladas: {totals.total.toFixed(2)} hrs
                </div>
                <div style={{ fontSize: '0.85rem', color: '#666' }}>
                  (Tránsito: {totals.horasTramoTotal.toFixed(2)}h + Tiempo Operativo Fijo Estaciones Intermedias: {totals.tiempoOperativoTotal.toFixed(2)}h)
                </div>
              </div>
            </div>

            <div style={{ marginBottom: 15, display: 'flex', gap: 10 }}>
              <Button onClick={this.onAddSucursal} variant="contained" color="secondary">
                + Añadir Estación / Sucursal
              </Button>
              <Button onClick={this.onSave} disabled={saving} variant="contained" color="primary">
                {saving ? 'Guardando...' : 'Guardar Circuito'}
              </Button>
            </div>
          </CardContent>
        </Card>

        <div className="row">
          <div className="col-sm-12">
            {sucursales.map((sucursalItem, index) => {
              const selectedId = typeof sucursalItem === 'object' ? sucursalItem.id_sucursal : sucursalItem;
              const horasTramo = typeof sucursalItem === 'object' ? (sucursalItem.horas_tramo || 0) : 0;
              const isLastStop = index === sucursales.length - 1;

              return (
                <Card key={`sucursal-card-${index}`} variant="outlined" style={{ marginBottom: 10, background: '#fafafa' }}>
                  <CardContent style={{ padding: '12px 16px' }}>
                    <div className="row" style={{ alignItems: 'center' }}>
                      <div className="col-md-2 col-sm-2" style={{ fontWeight: 'bold', textAlign: 'center' }}>
                        Parada #{index + 1} {index === 0 ? '(Origen)' : isLastStop ? '(Destino Final)' : '(Intermedia)'}
                      </div>

                      <div className="col-md-5 col-sm-10">
                        <Select
                          fullWidth
                          onChange={(e) => this.onChangeSucursalId(index, e.target.value)}
                          value={selectedId || ''}
                          variant="outlined"
                          displayEmpty
                        >
                          <MenuItem value="" disabled>Seleccione Sucursal</MenuItem>
                          {safeOptions.map(suc => (
                            <MenuItem key={`item-${suc.id}`} value={suc.id}>
                              {suc.sucursal || suc.sucursal_nombre}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>

                      <div className="col-md-3 col-sm-8">
                        {!isLastStop ? (
                          <TextField
                            fullWidth
                            label="Horas de Tránsito a la siguiente parada"
                            type="number"
                            inputProps={{ step: "0.5", min: "0" }}
                            value={horasTramo}
                            onChange={(e) => this.onChangeTramoField(index, 'horas_tramo', e.target.value)}
                            variant="outlined"
                            size="small"
                          />
                        ) : (
                          <div style={{ fontStyle: 'italic', color: '#1976d2', fontWeight: 500, paddingTop: 6 }}>
                            🏁 Estación Final / Destino
                          </div>
                        )}
                      </div>

                      <div className="col-md-2 col-sm-2" style={{ display: 'flex', justifyContent: 'flex-end', gap: 5 }}>
                        <IconButton
                          size="small"
                          disabled={index === 0}
                          onClick={() => this.onMoveSucursal(index, -1)}
                          title="Mover Arriba"
                        >
                          <Icon>arrow_upward</Icon>
                        </IconButton>
                        <IconButton
                          size="small"
                          disabled={index === sucursales.length - 1}
                          onClick={() => this.onMoveSucursal(index, 1)}
                          title="Mover Abajo"
                        >
                          <Icon>arrow_downward</Icon>
                        </IconButton>
                        <IconButton
                          size="small"
                          color="secondary"
                          onClick={() => this.onRemoveSucursal(index)}
                          title="Eliminar Estación"
                        >
                          <Icon>delete</Icon>
                        </IconButton>
                      </div>
                    </div>

                    {index > 0 && index < sucursales.length - 1 && (
                      <div style={{ marginTop: 6, fontSize: '0.78rem', color: '#888', fontStyle: 'italic' }}>
                        * Estación intermedia: Se incluyen automáticamente 2.0 hrs (120 min) de tiempo operativo fijo para el cálculo acumulado.
                      </div>
                    )}
                  </CardContent>
                </Card>
              );
            })}

            {sucursales.length === 0 && (
              <div style={{ textAlign: 'center', padding: 30, color: '#888', background: '#f5f5f5', borderRadius: 8 }}>
                No hay sucursales agregadas al circuito. Haga clic en "+ Añadir Estación / Sucursal".
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Circuito)